import { ICompleteEnrollmentDto } from './../../../../../models/complete-enrollment-dto';
import { EnrollmentAthleteService } from '@shared/services/enrollment-athlete.service';
import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';

@Component({
  selector: 'sigecom-modal-equipe',
  templateUrl: './modal-equipe.component.html'
})
export class ModalEquipeComponent implements OnInit {
  
  readonly #enrollmentAthleteService = inject(EnrollmentAthleteService)

  @Output() modalDetailParticipant = new EventEmitter<boolean>();
  @Output() atlNrId = new EventEmitter<number>();
  @Input() incNrId!: number;

  selectedParticipante: any = null;
  currentPage = 1;

  iCompleteEnrollmentDto = signal<ICompleteEnrollmentDto | null>(null)

  ngOnInit(): void {
    this.#findParticipants();
  }

  incTxResumoChange(incTxNome: string) {

  }

  #findParticipants() {
    this.#enrollmentAthleteService.findCompleteById(this.incNrId).subscribe({
      next: (res) => {
        this.iCompleteEnrollmentDto.set(res);
      }
    })
  }

  onPageChange(page: number) {

  }

  openDetails(atlNrId: number) {
    this.modalDetailParticipant.emit(true);
    this.atlNrId.emit(atlNrId);
    // this.selectedParticipante = participante;
  }

}
